/**
 * 租户信息
 */
import { defineStore } from 'pinia';
import { useLocalStorage, useSessionStorage } from '@vueuse/core';
import { accMul, creatWebIco, getJSON, getLocalStorage, isMobile, setJSON } from '@star/utils';
import { find, get } from 'lodash-es';
import { config, ConfigUtils } from '@star/config';
import { appServices } from '../services';
import $ from 'jquery';
import network from '../network';
import { useHot } from '../useHot';
import { showFailToast } from 'vant';

interface TenantInfo {
  proxy: number;
  domain_addr: string;
  webtitle: string; // 网站名字
  tid: number;
  rightIdDict: Object;
  tenant: {
    tid: number;
    [propName: string]: any;
  };
  sysOptions: {
    [propName: string]: any;
  };

  [propName: string]: any;
}

interface Countrys {
  [propName: string]: any;
}

export const useTenantStore = defineStore({
  id: 'tenant',
  state: () => {
    let tenantInfo: TenantInfo = {
      proxy: 0,
      domain_addr: '',
      webtitle: '',
      tid: 0, // 3
      rightIdDict: {},
      tenant: {
        tid: 0,
      },
      sysOptions: {},
    };
    const countrys: Countrys = {};
    const custContact = {
      Z1_confirm_password: 0,
      Z1_real_name: 0,
      Z1_nickname: 0,
      Z1_mobile_phone: 0,
      Z1_qq: 0,
      Z1_email: 0,
      Z1_zalo: 0,
      Z1_line: 0,
      Z1_facebook: 0,
      Z1_whatsApp: 0,
      Z1_code: 0,
      Z1_withdrawal_password: 0,
      Z1_telegram: 0,
      Z2_confirm_password: 0,
      Z2_real_name: 0,
      Z2_nickname: 0,
      Z2_mobile_phone: 0,
      Z2_qq: 0,
      Z2_email: 0,
      Z2_zalo: 0,
      Z2_line: 0,
      Z2_facebook: 0,
      Z2_whatsApp: 0,
      Z2_code: 0,
      Z2_withdrawal_password: 0,
      Z2_telegram: 0,
    };
    // 易盾智能验证
    const aiCaptcha = {
      loginInstance: null,
      registerInstance: null,
      isLoadScript: false,
    } as { loginInstance?: any; registerInstance?: any; isLoadScript: boolean };
    return {
      aiCaptcha,
      logoSrc: useLocalStorage<string>('APP_LOGO_SRC', ''),
      downloadLogoSrc: useLocalStorage<string>('APP_DOWNLOAD_LOGO_SRC', ''),
      pageLoading: false,
      commissionList: [], // 佣金表
      tenantInfo: useSessionStorage<Record<string, any>>('TENANT_INFO', { ...tenantInfo }),
      backupWebsites: [] as any[], // 备用地址
      registerSysOptions: {}, // 注册配置
      tResLoc: '', // 后台回来的主题名
      imgDomain: '',
      areaLists: [], // 汇率列表
      // 找出默认的后台计价方式 [默认第一个]
      defaultArea: { area: 'CNY', huilv: 1 },
      // account 账号登录 email_captcha 邮件登录 phone_captcha 短信登录 email_pwd_captcha 邮箱密码登录 phone_pwd_captcha 手机验证+密码
      loginMode: '',
      // account 账号注册 email_captcha 邮件注册 phone_captcha 短信注册 email_pwd_captcha 邮箱密码注册 phone_pwd_captcha 手机验证+密码
      registerMode: '',
      // // 验证码是否显示
      verifyCodeFlag: false,
      // 发送短信的国际编号
      countrys,
      aseq: <any>{
        magic_key: '',
      },
      // 租户后台设置
      activeConfiguration: {},
      activeConfigurationDesc: {}, // 代理盘对应的描述信息
      activeConfigurationDescDetail: {}, // 代理盘对应的描述信息详情
      // 控制是否显示的
      custContact: custContact,
      // 登录选项的各种配置
      sysLoginOptions: {
        CUST_LOGIN_CAPTCHA_MODE: {
          SMART_SWITCH: '',
          Z2_M_SMART_CAPTCHA_MODE: '',
          Z2_PC_SMART_CAPTCHA_MODE: '',
          PICTURE_SWITCH: '',
        },
        CUST_LOGIN_MODE: {},
        CUST_LOGIN_SPECIAL_CAPTCHA: '',
        SMS_OPEN_COUNTRY: {},
        BET_AMOUNT_UNIT: 1,
      } as Record<string, any>,
      // 注册选项的各种配置
      sysRegisterOptions: {
        CUST_CONTACT_LIST: '',
        CUST_REGISTER_CAPTCHA_MODE: {
          SMART_SWITCH: '',
          Z2_M_SMART_CAPTCHA_MODE: '',
          Z2_PC_SMART_CAPTCHA_MODE: '',
          PICTURE_SWITCH: '',
        },
        CUST_REGISTER_MODE: {},
        CUST_REGISTER_PASSWORD_MODE: {
          PASSWORD_MODE: '',
        },
        SMS_OPEN_COUNTRY: {},
      },
      // 注册登录配置已经获取到了 不需要每次获取
      sysRegAndLoginOptLoaded: null, // 登录注册配置原始数据
      bankList: [], // 银行卡列表
      showBargainingChip: 1,
      amountPK: 0,
      sideMenu: {
        left: [],
        right: [],
        leftDown: [],
        rightDown: [],
      },
      IPLimit: false, // ip限制
      systemRepair: false, // 网站维护
      repairData: {}, // 网站维护数据
      isReqPlatformData: useSessionStorage<boolean>('IS_REQ_PLATFORM_DATA', true), // 是否二次请求371130接口数据
    } as Record<string, any>;
  },
  getters: {
    isRepairing: state => {
      return !!state.systemRepair || state.repairData?.server_state === '2';
    },
    websiteName: state => state.tenantInfo?.tenant?.tenant_name,
    cfg51la: (state): { id: string; ck: string } => {
      return {
        id: state.tenantInfo?.sysOptions?.['51LA_ID'],
        ck: state.tenantInfo?.sysOptions?.['51LA_CK'],
      };
    },
  },
  actions: {
    // 选择默认计价方式 update是否更新计价
    selectArea(data, update = false) {
      const KEY = 'localArea'; // 本地计价方式key
      const list = this.areaLists;
      let tmpObj = getJSON(KEY) || { area: '' };
      let loc = list.find(item => item.area === tmpObj.area) || null; // 查找是否在列表中
      setJSON(KEY, update ? data : loc || data);
      this.defaultArea = update ? data : loc || data;
    },
    setLogo(info: any) {
      this.logoSrc = get(
        find(info?.logo_manage, item => item.message_id === 29 && item.pic_addr),
        'pic_addr'
      ) as string;
      this.downloadLogoSrc = get(
        find(info?.logo_manage, item => item.message_id === 34),
        'pic_addr'
      ) as string;
    },
    setWebIco(info: any) {
      const url = get(
        find(info?.logo_manage, item => item.message_id === 30 && item.pic_addr),
        'pic_addr'
      ) as string;
      if (url) {
        creatWebIco(url);
      }
    },
    async getPlatformData() {
      try {
        let domain_addr = location.origin;
        // @ts-ignore
        console.log(import.meta.env.DEV, 'import.meta.env.DEV');
        if (import.meta.env.DEV) {
          // @ts-ignore
          domain_addr = import.meta.env.VITE_API_DOMAIN_ADDR;
        }
        const res: any = await appServices.getPlatformData({
          domain_addr: domain_addr,
          language: '0',
        });
        if (res.type === 'success') {
          this.tenantInfo = res.data;
          this.setLogo(this.tenantInfo);
          this.setWebIco(this.tenantInfo);
          res.data?.listShow && this.setActiveConfiguration(res.data?.listShow); // 代理盘控制数据

          console.log(this.activeConfiguration, 'activeConfiguration');
          // 代理盘2的时候显示xmpp，其他的时候租户名
          if (+res.data.proxy === 2) {
            document.title = res.data.tenant.xmpp;
          } else {
            document.title = res.data.tenant.tenant_name;
          }
          this.tenantInfo.webtitle = res.data.tenant.tenant_name || '';
          const checkUrl = url => {
            if (/^http/.test(url)) {
              if (!/\/$/.test(url)) {
                return `${url}/`;
              } else {
                return url;
              }
            } else {
              return url;
            }
          };
          this.imgDomain = checkUrl(
            this.tenantInfo.imgs_domain && this.tenantInfo.imgs_domain[0]
              ? this.tenantInfo.imgs_domain[0].domain_addr
              : ''
          );
          this.reqImgsUrl(this.tenantInfo.imgs_domain || []);
          this.standardTenant();
          // await useGameStore().reqConfigJson();
          // 设置chan_code
          config.channelCode = res.data.chan_code || '';
          // this.setTheme(); // 设置主题
        }
        return Promise.resolve(res?.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    // 规范数据结构
    standardTenant() {
      if (this.tenantInfo.sysOptions) {
        // 存入 sysLoginOptions 登录配置数据
        this.setContactConfig({ sysLoginOptions: ConfigUtils.deepCopy(this.tenantInfo.sysOptions) });
        const CUST_LOGIN_CAPTCHA_MODE = this.tenantInfo.sysOptions.CUST_LOGIN_CAPTCHA_MODE;
        if (CUST_LOGIN_CAPTCHA_MODE) {
          this.tenantInfo.sysOptions.CUST_LOGIN_CAPTCHA_MODE = JSON.parse(CUST_LOGIN_CAPTCHA_MODE);
          // this.setVerifyCodeFlag()
        }
        const CUST_LOGIN_MODE = this.tenantInfo.sysOptions.CUST_LOGIN_MODE;
        if (CUST_LOGIN_MODE) {
          this.tenantInfo.sysOptions.CUST_LOGIN_MODE = JSON.parse(CUST_LOGIN_MODE);
        }
        const CUST_REGISTER_PASSWORD_MODE = this.tenantInfo.sysOptions.CUST_REGISTER_PASSWORD_MODE;
        if (CUST_REGISTER_PASSWORD_MODE) {
          this.tenantInfo.sysOptions.CUST_REGISTER_PASSWORD_MODE = JSON.parse(CUST_REGISTER_PASSWORD_MODE);
          this.tenantInfo.sysOptions.PASSWORD_MODE = JSON.parse(CUST_REGISTER_PASSWORD_MODE).PASSWORD_MODE;
        }
        const LANGUAGE_IS_DISPLAY = this.tenantInfo.sysOptions.LANGUAGE_IS_DISPLAY;
        if (LANGUAGE_IS_DISPLAY) {
          this.tenantInfo.sysOptions.LANGUAGE_IS_DISPLAY = JSON.parse(LANGUAGE_IS_DISPLAY);
        }
        const PRICING_METHOD = this.tenantInfo.sysOptions.PRICING_METHOD;
        if (PRICING_METHOD) {
          let PRICING = JSON.parse(PRICING_METHOD);
          this.tenantInfo.sysOptions.PRICING_METHOD = PRICING;
          // 设置默认计价方式
          this.areaLists = PRICING;
          this.selectArea(PRICING[0]);
        }
        const SMS_OPEN_COUNTRY = this.tenantInfo.sysOptions.SMS_OPEN_COUNTRY;
        if (SMS_OPEN_COUNTRY) {
          this.tenantInfo.sysOptions.SMS_OPEN_COUNTRY = JSON.parse(SMS_OPEN_COUNTRY);
          this.countrys = this.tenantInfo.sysOptions.SMS_OPEN_COUNTRY;
          setJSON('countrys', this.countrys);
        }
        const YIDUN_CAPTCHA_ID = this.tenantInfo.sysOptions.YIDUN_CAPTCHA_ID;
        if (YIDUN_CAPTCHA_ID) {
          this.tenantInfo.sysOptions.YIDUN_CAPTCHA_ID = JSON.parse(YIDUN_CAPTCHA_ID);
        } else {
          this.tenantInfo.sysOptions.YIDUN_CAPTCHA_ID = {};
        }
        const BET_AMOUNT_UNIT = this.tenantInfo.sysOptions.BET_AMOUNT_UNIT;
        if (BET_AMOUNT_UNIT) {
          this.showBargainingChip = Number(BET_AMOUNT_UNIT);
        }
        const PLAYPLAN_RESTRICT_REWARD_PER_TERMCODE = this.tenantInfo.sysOptions.PLAYPLAN_RESTRICT_REWARD_PER_TERMCODE;
        if (PLAYPLAN_RESTRICT_REWARD_PER_TERMCODE) {
          this.amountPK = Number(accMul(PLAYPLAN_RESTRICT_REWARD_PER_TERMCODE, 0.0001));
        }
        const WAIHUI_TYPE_DATA = this.tenantInfo.sysOptions.WAIHUI_TYPE_DATA;
        if (WAIHUI_TYPE_DATA) {
          this.tenantInfo.sysOptions.WAIHUI_TYPE_DATA = JSON.parse(WAIHUI_TYPE_DATA);
        }
      }
      if (this.tenantInfo.tenant) {
        // online_addr 主盘在线客服地址
        // online_addr1 代理盘1在线客服地址
        // online_addr2 代理盘2在线客服地址
        // online_addr3 代理盘3在线客服地址
        // type 主盘在线客服地址是否三方 0自己，1三方
        // type1 代理盘1在线客服地址是否三方 0自己，1三方
        // type2 代理盘2在线客服地址是否三方 0自己，1三方
        // type3 代理盘3在线客服地址是否三方 0自己，1三方
        // activity_address 主盘账号交易在线客服地址
        // activity_address1 代理盘1账号交易在线客服地址
        // activity_address2 代理盘2账号交易在线客服地址
        // activity_address3 代理盘3账号交易在线客服地址
        // zhjy_type 主盘账号交易在线客服地址是否三方 0自己，1三方
        // zhjy_type1 代理盘1账号交易在线客服地址是否三方 0自己，1三方
        // zhjy_type2 代理盘2账号交易在线客服地址是否三方 0自己，1三方
        // zhjy_type3 代理盘3账号交易在线客服地址是否三方 0自己，1三方
        let proxyType = +this.tenantInfo.proxy === 0 ? '' : String(this.tenantInfo.proxy);
        this.tenantInfo.tenant.type =
          this.tenantInfo.tenant[`type${proxyType}`] !== undefined
            ? this.tenantInfo.tenant[`type${proxyType}`]
            : this.tenantInfo.tenant.type;
        this.tenantInfo.tenant.zhjy_type =
          this.tenantInfo.tenant[`zhjy_type${proxyType}`] !== undefined
            ? this.tenantInfo.tenant[`zhjy_type${proxyType}`]
            : this.tenantInfo.tenant.zhjy_type;
        this.tenantInfo.tenant.online_addr =
          this.tenantInfo.tenant[`online_addr${proxyType}`] !== undefined
            ? this.tenantInfo.tenant[`online_addr${proxyType}`]
            : this.tenantInfo.tenant.online_addr;
        this.tenantInfo.tenant.activity_address =
          this.tenantInfo.tenant[`activity_address${proxyType}`] !== undefined
            ? this.tenantInfo.tenant[`activity_address${proxyType}`]
            : this.tenantInfo.tenant.activity_address;
        // official_addr 安卓下载地址主盘
        // official_addr1 安卓下载地址代理盘1
        // official_addr2 安卓下载地址代理盘2
        // official_addr3 安卓下载地址代理盘3
        // app_reg_addr 苹果下载地址主盘
        // app_reg_addr1 苹果下载地址代理盘1
        // app_reg_addr2 苹果下载地址代理盘2
        // app_reg_addr3 苹果下载地址代理盘3
        this.tenantInfo.tenant.official_addr =
          this.tenantInfo.tenant[`official_addr${proxyType}`] !== undefined
            ? this.tenantInfo.tenant[`official_addr${proxyType}`]
            : this.tenantInfo.tenant.official_addr;
        this.tenantInfo.tenant.app_reg_addr =
          this.tenantInfo.tenant[`app_reg_addr${proxyType}`] !== undefined
            ? this.tenantInfo.tenant[`app_reg_addr${proxyType}`]
            : this.tenantInfo.tenant.app_reg_addr;
      }
    },
    setContactConfig(data) {
      // 注册相关的配置
      if (data.sysOptions) {
        const sysRegisterOptions = data.sysOptions;
        const CUST_CONTACT_LIST = sysRegisterOptions.CUST_CONTACT_LIST;
        if (CUST_CONTACT_LIST) {
          const requiredArr = CUST_CONTACT_LIST.split(';');
          const tmpObj = {};
          requiredArr.forEach(item => {
            const current = item.split(',');
            current.forEach(cItem => {
              const cItemTmp = cItem.split(':');
              if (cItemTmp[0]) {
                tmpObj[cItemTmp[0]] = Number(cItemTmp[1]);
              }
            });
          });
          this.custContact = tmpObj;
        }
        const CUST_REGISTER_CAPTCHA_MODE = sysRegisterOptions.CUST_REGISTER_CAPTCHA_MODE;
        if (CUST_REGISTER_CAPTCHA_MODE) {
          sysRegisterOptions.CUST_REGISTER_CAPTCHA_MODE = JSON.parse(CUST_REGISTER_CAPTCHA_MODE);
        }
        const CUST_REGISTER_MODE = sysRegisterOptions.CUST_REGISTER_MODE;
        if (CUST_REGISTER_MODE) {
          sysRegisterOptions.CUST_REGISTER_MODE = JSON.parse(CUST_REGISTER_MODE);
          if (sysRegisterOptions.CUST_REGISTER_MODE?.account === '1') {
            this.registerMode = 'account';
          } else if (sysRegisterOptions.CUST_REGISTER_MODE?.email_captcha === '1') {
            this.registerMode = 'email_captcha';
          } else if (sysRegisterOptions.CUST_REGISTER_MODE?.phone_captcha === '1') {
            this.registerMode = 'phone_captcha';
          } else if (sysRegisterOptions.CUST_REGISTER_MODE?.phone_pwd_captcha === '1') {
            this.registerMode = 'phone_pwd_captcha';
          }
        }
        const CUST_REGISTER_PASSWORD_MODE = sysRegisterOptions.CUST_REGISTER_PASSWORD_MODE;
        if (CUST_REGISTER_PASSWORD_MODE) {
          sysRegisterOptions.CUST_REGISTER_PASSWORD_MODE = JSON.parse(CUST_REGISTER_PASSWORD_MODE);
        }
        const SMS_OPEN_COUNTRY = sysRegisterOptions.SMS_OPEN_COUNTRY;
        if (SMS_OPEN_COUNTRY) {
          sysRegisterOptions.SMS_OPEN_COUNTRY = JSON.parse(SMS_OPEN_COUNTRY);
        }
        const YIDUN_CAPTCHA_ID = sysRegisterOptions.YIDUN_CAPTCHA_ID;
        if (YIDUN_CAPTCHA_ID) {
          sysRegisterOptions.YIDUN_CAPTCHA_ID = JSON.parse(YIDUN_CAPTCHA_ID);
        }
        this.sysRegisterOptions = sysRegisterOptions;
      }
      // 登录相关的配置
      if (data.sysLoginOptions) {
        const sysLoginOptions = data.sysLoginOptions;
        const CUST_LOGIN_CAPTCHA_MODE = sysLoginOptions.CUST_LOGIN_CAPTCHA_MODE;
        if (CUST_LOGIN_CAPTCHA_MODE) {
          sysLoginOptions.CUST_LOGIN_CAPTCHA_MODE = JSON.parse(CUST_LOGIN_CAPTCHA_MODE);
        }
        console.log('data.sysLoginOptions', data.sysLoginOptions);
        const CUST_LOGIN_MODE = sysLoginOptions.CUST_LOGIN_MODE;
        if (CUST_LOGIN_MODE) {
          sysLoginOptions.CUST_LOGIN_MODE = JSON.parse(CUST_LOGIN_MODE);
          if (sysLoginOptions.CUST_LOGIN_MODE?.account === '1') {
            this.loginMode = 'account';
          } else if (sysLoginOptions.CUST_LOGIN_MODE?.phone_captcha === '1') {
            this.loginMode = 'phone_captcha';
          } else if (sysLoginOptions.CUST_LOGIN_MODE?.email_captcha === '1') {
            this.loginMode = 'email_captcha';
          } else if (sysLoginOptions.CUST_LOGIN_MODE?.email_pwd_captcha === '1') {
            this.loginMode = 'email_pwd_captcha';
          } else if (sysLoginOptions.CUST_LOGIN_MODE?.phone_pwd_captcha === '1') {
            this.loginMode = 'phone_pwd_captcha';
          }
        }
        const SMS_OPEN_COUNTRY = sysLoginOptions.SMS_OPEN_COUNTRY;
        if (SMS_OPEN_COUNTRY) {
          sysLoginOptions.SMS_OPEN_COUNTRY = JSON.parse(SMS_OPEN_COUNTRY);
        }
        const YIDUN_CAPTCHA_ID = sysLoginOptions.YIDUN_CAPTCHA_ID;
        if (YIDUN_CAPTCHA_ID) {
          sysLoginOptions.YIDUN_CAPTCHA_ID = JSON.parse(YIDUN_CAPTCHA_ID);
        }
        const BET_AMOUNT_UNIT = sysLoginOptions.BET_AMOUNT_UNIT;
        if (BET_AMOUNT_UNIT) {
          this.showBargainingChip = Number(BET_AMOUNT_UNIT);
        }
        const PLAYPLAN_RESTRICT_REWARD_PER_TERMCODE = sysLoginOptions.PLAYPLAN_RESTRICT_REWARD_PER_TERMCODE;
        if (PLAYPLAN_RESTRICT_REWARD_PER_TERMCODE) {
          this.amountPK = Number(accMul(PLAYPLAN_RESTRICT_REWARD_PER_TERMCODE, 0.0001));
        }
        this.sysLoginOptions = sysLoginOptions;
      }
    },
    setActiveConfiguration(data) {
      console.log(data, 'setActiveConfiguration');
      let obj = {};
      let descObj = {};
      let descObjDetail = {};
      data.map(item => {
        if (isMobile()) {
          obj[item.name] = Number(item.show_mobile);
        } else {
          obj[item.name] = Number(item.show_pc);
        }
        descObj[item.name] = item.show_des;
        descObjDetail[item.name] = item.detail || '';
      });
      setJSON('activeConfiguration', obj);
      this.activeConfiguration = obj;
      this.activeConfigurationDesc = descObj;
      this.activeConfigurationDescDetail = descObjDetail;
    },
    setIPLimitStatus(data) {
      this.IPLimit = data;
    },
    setRepairStatus(data) {
      this.systemRepair = data;
    },
    setRepairData(data: Record<string, any>) {
      this.repairData = data;
    },
    /**
     * 获取佣金列表数据
     */
    async reqCommissionList() {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      try {
        const res = await network.request({
          cmdId: 374032,
          data: { tid: tenantInfo.value.tid },
        });
        if (res && res.type === 'success') {
          this.commissionList = res.data;
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 获取备用网址
     */
    async reqWebsiteInfo(payload) {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      // 发起请求
      let data = {
        tid: tenantInfo.value.tid,
        chan_code: payload.chan_code || 'WEB_CHECK',
        page_start: payload.page_start,
        num_per_page: payload.num_per_page,
        weight: 0,
        state: 1,
        proxy: tenantInfo.value.proxy,
      };
      console.log(data, 'reqWebsiteInfoData');
      try {
        const res = await network.request({
          cmdId: 371137,
          data: data,
        });
        if (res && res.type === 'success') {
          if (res.data) {
            console.log(res.data, 'reqWebsiteInfo');
            if (payload.page_start < 2) {
              this.backupWebsites = [];
            }
            this.backupWebsites = this.backupWebsites
              .concat(Object.assign([], res.data.data))
              .sort((a, b) => a.weight - b.weight);
          }
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 图片线路探测
     */
    reqImgsUrl(payload) {
      const tmpFunc = index => {
        if (index >= payload.length) {
          return;
        }
        let domain_addr = payload[index].domain_addr;
        domain_addr && !/\/$/.test(domain_addr) && (domain_addr += '/');
        $.ajax({
          url: `${domain_addr}test.txt`,
          dataType: 'jsonp',
          type: 'get',
          timeout: 3000,
          complete: req => {
            if (req.status === 200) {
              if (this.imgDomain !== domain_addr) {
                this.imgDomain = domain_addr;
              }
            } else {
              tmpFunc(index + 1);
            }
          },
        });
      };
      tmpFunc(0);
    },
    /**
     * 请求租户注册联系人配置
     */
    async reqContactConfig() {
      if (this.sysRegAndLoginOptLoaded) return Promise.resolve(this.sysRegAndLoginOptLoaded);
      try {
        const res = await network.request({
          cmdId: 371143,
          data: {
            tid: this.tenantInfo.tid,
          },
          headerType: 1,
        });
        if (res && res.type === 'success') {
          this.setContactConfig(res.data);
          this.sysRegAndLoginOptLoaded = res.data || null; // 原始数据
          return Promise.resolve(res.data);
        } else {
          this.sysRegAndLoginOptLoaded = null;
          return Promise.reject(res);
        }
      } catch (e: any) {
        this.sysRegAndLoginOptLoaded = null;
        if (e?.data?.info) {
          showFailToast(e?.data?.info);
        }
        return Promise.reject(e);
      }
    },
    /**
     * 用于请求后端接口动态翻译
     * text：['彩票', '棋牌'],数组
     * language：cn  是中文  en是英文  th是泰文  vi是越南文
     */
    async translationText(payload: any = {}) {
      // 发起请求
      let data = {
        ...payload,
        text: payload.text,
        language: payload.language.value || getLocalStorage('language'),
      };
      try {
        const res = await network.request({
          cmdId: 3101343,
          data: data,
          headerType: 2,
          paramType: 1,
          isApiV2: true,
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * 获取银行卡
     */
    async reqNewBankList() {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;

      try {
        const res = await network.request({
          cmdId: 371234,
          data: [tenantInfo.value.tid],
          paramType: 2,
        });
        if (res && res.type === 'success') {
          this.bankList = res.data;
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /** 获取vip升级禁用列表信息 */
    async reqProhibitList() {
      const { hotData } = useHot();
      const { tenantInfo } = hotData;
      try {
        const res = await network.request({
          cmdId: 321539,
          data: {
            tid: tenantInfo.value.tid,
          },
        });
        if (res && res.type === 'success') {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res.data);
        }
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    },
    /**
     * @name 维护界面数据
     * tid=3
     */
    async reqRepairData(payload = {}) {
      try {
        let domain_addr = location.origin;
        // @ts-ignore
        if (import.meta.env.DEV) {
          // @ts-ignore
          domain_addr = import.meta.env.VITE_API_DOMAIN_ADDR;
        }
        let data = { domain_addr, ...payload };
        const res = await network.request({
          cmdId: 371138,
          data,
          headerType: 1,
          inHeaders: { Tid: '' },
        });
        if (res && res.type === 'success') {
          this.setRepairData(res.data);
          return Promise.resolve(res.data);
        } else {
          this.setRepairData({});
          return Promise.reject(res.data);
        }
      } catch (error) {
        // return Promise.reject(error.data);
      }
    },
  },
});
